import { ConfigProvider, theme } from 'antd';
import type { ThemeConfig } from 'antd';
import ru from 'antd/locale/ru_RU';
import type { ReactNode } from 'react';

const legacyTheme: ThemeConfig = {
  inherit: false,
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#35b2f6',
    colorBgContainer: '#303339',
    colorBgElevated: '#383b43',
    colorBorder: '#3d4149',
    colorBorderSecondary: '#5a606d',
    borderRadius: 10,
    borderRadiusLG: 14,
  },
};

export default function LegacyThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider theme={legacyTheme} locale={ru}>
      {children}
    </ConfigProvider>
  );
}
